import { render, staticRenderFns } from "./OccupationalMedicine.vue?vue&type=template&id=89f01174&"
import script from "./OccupationalMedicine.vue?vue&type=script&lang=js&"
export * from "./OccupationalMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports